import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Dashboard from "./Pages/Admin/Dashboard/Dashboard";
import Home from "./Pages/Admin/Home/Home";
import Login from "./Pages/Admin/Login/Login";
import PageNotFound from "./Pages/PageNotFound/PageNotFound";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import Profile from "./Pages/Admin/Profile/Profile";
import Exam from "./Pages/Admin/Exam/Exam";
import ExamDetails from "./Pages/Admin/ExamDetails/ExamDetails";
import ExamUpdate from "./Pages/Admin/Exam/ExamUpdate";
import Result from "./Pages/Result/Result";
import Student from "./Pages/Admin/Student/Student";
import BatchUpdate from "./Pages/Admin/Student/BatchUpdate";
import BatchDetails from "./Pages/Admin/Student/BatchDetails";
import StudentUpdate from "./Pages/Admin/Student/StudentUpdate";
import ListAllStudents from "./Components/Admin/Students/ListAllStudents";
import HomePage from "./Pages/HomePage/HomePage";

const App = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  return (
    <>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          theme="dark"
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
        />
        <Routes>
          <Route element={<ProtectedRoute adminToken={adminToken} />}>
            <Route
              path="/admin/profile"
              element={<Dashboard AnotherComponent={<Profile />} />}
            />
            <Route
              path="/admin/exams"
              element={<Dashboard AnotherComponent={<Exam />} />}
            />
            <Route
              path="/admin/exam-details/:id"
              element={<Dashboard AnotherComponent={<ExamDetails />} />}
            />
            <Route
              path="/admin/batch-details/:id"
              element={<Dashboard AnotherComponent={<BatchDetails />} />}
            />
            <Route
              path="/admin/update-exam/:id"
              element={<Dashboard AnotherComponent={<ExamUpdate />} />}
            />
            <Route
              path="/admin/update-batch/:id"
              element={<Dashboard AnotherComponent={<BatchUpdate />} />}
            />
            <Route
              path="/admin/update-student/:id"
              element={<Dashboard AnotherComponent={<StudentUpdate />} />}
            />
            <Route
              path="/admin/students"
              element={<Dashboard AnotherComponent={<Student />} />}
            />
            <Route
              path="/admin/all-students"
              element={<Dashboard AnotherComponent={<ListAllStudents />} />}
            />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/result" element={<Result />} />
          <Route
            path="/admin/dashboard"
            element={<Dashboard AnotherComponent={<Home />} />}
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
